/**
 * Label on a card's ALT toggle. When the card's own Min-books or Main Only
 * filter hides lines, say how many lines exist so the hidden ones are
 * findable (Oct 9, 2026: alt lines now reach the card; the default Min is the
 * user's minBooksStraights, so most 1–4 book alt lines start hidden).
 */
export function altToggleLabel(shown, total, { showMainOnly = false, minBooksFilter = 0 } = {}) {
    const filterNote = showMainOnly ? 'main only' : (minBooksFilter > 0 ? `${minBooksFilter}+ books` : '');
    if (shown === 0) return `0 lines (filtered from ${total})`;
    if (filterNote && total > shown) return `${shown} of ${total} lines · ${filterNote}`;
    return shown === 1 ? '1 line total' : `${shown} total lines`;
}
